<template>
  <v-app>
    <v-navigation-drawer
      :clipped="true"
      enable-resize-watcher
      fixed
      app
      justify-center>
      <img src="/static/interact_logo.png" alt="InterAct Training Group">
      <p class="slug-line">InterAct Training Group (ITG) is a family owned business that was founded in 1994 to help businesses meet and surpass the demands of today's business climate. We help organizations identify needed performance improvements and create interventions to drive those improvements.  We place special emphasis on creating positive change in company culture and behavior to give organizations the skills and knowledge needed to create the best outcomes possible.</p>
      <p class="address-block">
        <strong>InterAct Training Group</strong><br />
        2422 W Timbercreek Court<br />
        Wichita Kansas 67204<br />
        316.260.5239</p>
    </v-navigation-drawer>
    <v-toolbar
      app
      tabs
      :clipped-left="true">
      <v-toolbar-title v-text="title" class="header"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn 
        fab
        dark 
        small
        color="indigo" 
        @click="liLink">
        <i class="fab fa-linkedin-in"></i>
      </v-btn>
      <v-tabs slot="extension" grow color="transparent" slider-color="red darken-4">
        <v-tab 
          v-for="link in links" 
          :key="link.route" 
          :to="link.route">
          <v-icon small :class="`fas fa-${link.icon}`"></v-icon>
          <span class="tab-label">{{ link.label }}</span>
        </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
    <v-content>
      <v-layout
        justify-center
        row
        nowrap
        accent>
        <v-flex xs8>
          <div class="testimonial-block">{{ testimonial.quote }}</div>
          <div class="testimonial-person">{{ testimonial.person }}</div>
        </v-flex>
        </v-layout>
    </v-content>
    <v-footer height="auto" dark color="grey darken-3">
      <v-layout
        justify-center
        row
        wrap>
        <v-btn 
          v-for="link in links"
          :key="link.label"
          color="white"
          dark
          flat
          round
          :to="link.route">{{ link.label }}</v-btn>
        <v-flex
          py-3
          text-xs-center
          white--text
          xs12
          secondary>This website is designed, maintained and hosted by The Initiative Production Group.<br />
          &copy;{{ copyright }}</v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
  import moment from 'moment'

  export default {
    data () {
      return {
        drawer: true,
        links: [
          {
            label: 'home',
            route: '/',
            icon: 'home'
          },
          {
            label: 'services',
            route: '/services',
            icon: 'concierge-bell'
          },
          {
            label: 'topics',
            route: '/topics',
            icon: 'list-ul'
          },
          {
            label: 'about',
            route: '/about',
            icon: 'users'
          },
          {
            label: 'faq',
            route: '/faq',
            icon: 'question-circle'
          },
          {
            label: 'contact',
            route: '/contact',
            icon: 'envelope'
          }
        ],
        title: 'INTERACT TRAINING GROUP',
        tIndex: 0,
        testimonials: [
          {
            quote: 'I had the privilege to work with Vicki when Intek hired her for Sales Training. The curriculum that Vicki prepared was very methodical and engaging, which created a very positive environment for learning. Intek\'s team included sales associates as well as design engineers with different backgrounds and experiences. Vicki was able to customize our program, so all associates could relate to the material and learn different sales approaches and behaviors depending on their roles. I recommend hiring Vicki for future sales training for your organization. The results include not only sales and profit growth for your company, but building long term relationships that are a requirement for success.',
            person: 'Tracy Koch, Key Account Manager - Intek Plastics'
          },
          {
            quote: 'I would recommend Vicki Flesher to any business (large or small) wanting to invest in behavior change. She has been instrumental in leading our firm through improved sales processes, presentation skills and supervisory skills training. She invests time to understand your organization and its culture, builds training unique to you, and includes components that keep training alive long after class is out! You will not be disappointed.',
            person: 'Christina Ricke, People Strategy Leader - KCOE ISOM'
          },
          {
            quote: 'I initially hired Vicki a number of years ago to provide consulting to our firm in the area of sales and marketing. After success with several projects, we invited Vicki to be a part of our firm for several years as a consultant, and she provided our clients significant benefits in the area of sales and business development consulting. In recent years, she has continued to provide creative, results oriented training for our executive level staff in the area of sales, including personal coaching of several of our experienced staff in the area of sales. She provides leadership, creativity, and deep expertise in achieving results!',
            person: 'Kurt Siemers, CEO - Retired - Kennedy and Coe, LLC'
          },
          {
            quote: 'It is my pleasure to recommend Vicki for any role. The two of us worked together on an implementation of global interview training. She was certified as a "train-the-trainer" and on numerous occasions, facilitated training for Cargill. In addition, when we underwent a major revision of our training content, Vicki designed procedures and unique documents for Cargill that could be used for our training that were used around the world in our interview training deployment efforts. Vicki produces work that consistently exceeds my expectations. She is always well prepared and thorough with details. She is always one of the first people I think of if I need someone who is an excellent facilitator who can capture an audience with her professionalism, or if I need someone to design a process from start to finish; she is reliable, timely, and detail-oriented. I highly recommend Vicki. You will never be disappointed.',
            person: 'Jodi Hill, MA, Sr. Learning & Development Specialist - Donaldson Company, Inc.'
          },
          {
            quote: 'I worked with Vicki on a large project to design and deliver sales training for the Cargill Meat Solutions sales organization. Vicki studied our business, interviewed key leaders in the organization, designed a curriculum that was customized to our unique selling environment, and created tools to help us both measure the effectiveness of the curriculum and make the training stick. Vicki is an engaging facilitator and makes learning fun. The curriculum she designed has been delivered more than 60 times and to business units in Cargill, beyond Cargill Meat Solutions. She is ethical, disciplined, and easy to work with.',
            person: 'Rob Heithoff, Vice President and Group Director - Cargill Animal Nutrition'
          },
          {
            quote: 'Vicki is an outstanding person of the highest integrity. She has helped me with sales training in several companies and I will hire her again in a heartbeat if I have the need.',
            person: 'John Penn, National Director - AARP'
          },
          {
            quote: 'I have had the privilege to work with Vicki on numerous occasions. She provided our organization with an awesome series of training. Vicki took the time to get to know our company and our needs, and tailored the training making it right for us! She is an excellent facilitator, who is very passionate about the work she does and the people she serves. I would recommend her services to anyone!',
            person: 'Dusty Pfaff, Director of HR - Kanza Bank'
          },
          {
            quote: 'Vicki is a very talented sales professional. During her tenure at Lab Management Services she built a number of strategic relationships with hospital administrators, physicians, reference labs, and diagnostic equipment manufacturers. She also played a valuable role of coaching others in their business development efforts. She developed opportunities for the firm that were profitable and that created value for our clients. Without hesitation I would recommend Vicki Flesher. Her business development experience and coaching skills are excellent.',
            person: 'Judy Brockert, President - Lab Management Services, Inc.'
          },
          {
            quote: 'I had the opportunity to both engage Vicki to help Kennedy and Coe consider their training services, then work with her when she joined the firm to develop training and consulting services. She has excellent critical thinking skills and translates those into very effective training design, implementation and follow-through programs. I learned a great deal from her about the process of individual learning and change, and would highly recommend her to any organization on the path to improvement.',
            person: 'Lance Woodbury, Co-founder at Ag Progress, LLC - Ag Progress, LLC'
          },
          {
            quote: 'I have had the opportunity to co-facilitate and collaborate on design work with Vicki while consulting with Cargill, Inc. Vicki takes the initiative to make sure that her programs fit with the business needs of the company as well as the individual participant needs. She is a dynamic and engaging facilitator as well as a strategic business partner.',
            person: 'April Keller SPHR SHRM-SC, Talent Management Senior Director - ABM Industries'
          },
          {
            quote: 'Vicki is an amazing trainer, with a dynamic and energetic approach that is infectious! I continue to look for ways to connect with her and would highly recommend her to any organization who wants to improve their skills...Vicki will exceed your expectations and you will have a lot of fun along the way!',
            person: 'Candace Wilson, CPSM, Marketing Manager - UCI'
          }
        ],
        miniVariant: false
      }
    },
    computed: {
      copyright () {
        return `${moment().year()} InterAct Training Group`
      },
      testimonial () {
        return this.testimonials[this.tIndex]
      }
    },
    methods: {
      liLink () {
        window.open('https://www.linkedin.com/in/vickiflesher/', '_blank')
      }
    },
    mounted () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.drawer = false
      }
      const isMobile = window.matchMedia('only screen and (max-width: 760px)')
      if (isMobile.matches) {
        this.drawer = false
      }
      let i = 0
      setInterval(() => {
        if (i < this.testimonials.length) {
          i = (i + 1)
        } else {
          i = 0
        }
        this.tIndex = i
      }, 18000)
    },
    name: 'App'
  }
</script>

<style>
  p {
    color: #666666;
  }
  h3.sub-header {
    width: 100%;
    padding: 0 10px;
    margin: 20px 0 10px 0;
    background: #966464;
    color: #FFF;
    text-shadow: 1px 1px 2px #784546;
  }
  h3 > p {
    margin-bottom: 20px;
  }
  .header {
    letter-spacing: none;
    font-size: 1.15em;
    color: #999999;
  }
  .tab-label {
    display: none;
    margin-left: 5px;
  }
  .slug-line {
    padding: 20px;
    text-align: justify;
  }
  .v-footer {
    justify-content: center;
  }
  .v-navigation-drawer img {
    display: block;
    margin: 0 auto;
    margin-top: 20px;
  }
  .v-navigation-drawer p {
    color: #999999;
  }
  p.address-block {
    padding: 20px;
    color: #333333;
  }
  .training-banner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    background: #982b2d;
    color: #FFF;
    padding: 10px;
  }
  .training-banner button {
    width: 100%;
    text-transform: uppercase;
    margin: 0;
  }
  .testimonial-block {
    color: #FFFFFF;
    text-align: center;
    font-size: 1.15em;
    padding: 20px;
  }
  .testimonial-person {
    text-align: center;
    color: #EFEFEF;
    font-style: italic;
    padding-bottom: 10px;
  }
  @media all and (min-width: 480px) {
    .training-banner {
      flex-direction: row;
      justify-content: space-between;
    }
    .training-banner h2 {
      display: inline-block;
    }
    .training-banner button {
      width: auto;
      padding: 5px 20px;
    }
  }
  @media all and (min-width: 700px) {
    .header {
      letter-spacing: 1em;
      font-size: 1.25em;
    }
    .tab-label {
      display: inline-block;
    }
  }
  @media all and (min-width: 940px) {
    .header {
      letter-spacing: 1.25em;
      font-size: 1.5em;
    }
  }
</style>




// WEBPACK FOOTER //
// src/App.vue